import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { getNoticeGiftHonorTextColor } from '@components/LocalMerchant/Decoration/util'

@inject('decorationStore')
@observer
class Title extends Component {
  static defaultProps = {
    showNumber: true
  }

  render() {
    const {
      decorationStore: { newThemeConfig },
      title,
      num,
      showNumber
    } = this.props
    return (
      <div style={{ width: 70, marginRight: 18, flexShrink: 0 }}>
        <div
          style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: newThemeConfig['moduleTitle']
          }}
        >
          {title}
        </div>

        {showNumber && <div style={{ fontSize: 13, color: '#999' }}>{num}</div>}
      </div>
    )
  }
}

const Content = inject('decorationStore')(
  observer(({ content, decorationStore: { theme } }) => (
    <div
      style={{
        fontSize: 15,
        flexShrink: 0,
        maxWidth: 154,
        color: getNoticeGiftHonorTextColor(theme)
      }}
    >
      {content}
    </div>
  ))
)

@inject('decorationStore')
@observer
export default class extends Component {
  static Title = Title
  static Content = Content

  render() {
    const {
      decorationStore: { themeConfig },
      children,
      style,
      ...rest
    } = this.props

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          borderBottom: `1px solid ${themeConfig['line']}`,
          width: '100%',
          ...style
        }}
        {...rest}
      >
        {children}
      </div>
    )
  }
}
